import { Button, Modal } from "@arco-design/web-react";
import React from "react";
import { Importer, ImporterField } from "react-csv-importer";
import { normalizeImportRows } from "./contactImport";

// MUI -> Arco. Dialog(+Title/Content/Actions) -> Modal with visible/onCancel/
// title. The DialogActions only held a Cancel button, so the Modal renders a
// custom footer with a single Cancel button. Import logic is untouched.
export default function ContactImportDialog({ onSave, isOpen, setIsOpen, render }) {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleSave = (rows) => {
    // normalizeImportRows turns the optional comma-separated "Subscriptions"
    // column into [{ list_name }] (tolerating an absent column + blanks).
    onSave && onSave(normalizeImportRows(rows));
    handleClose();
  };


  return (
    <>
      {render(handleClickOpen)}
      <Modal
        visible={isOpen}
        onCancel={handleClose}
        title="Import Contacts"
        style={{ width: "90%", maxWidth: 600 }}
        footer={
          <Button onClick={handleClose} type="primary">
            Cancel
          </Button>
        }
      >
        <Importer
          dataHandler={async (rows) => {
            handleSave(rows);
          }}

          chunkSize={10000} // optional, internal parsing chunk size in bytes
          defaultNoHeader={false} // optional, keeps "data has headers" checkbox off by default
          restartable={false} // optional, lets user choose to upload another file when import is complete

        >
          <ImporterField name="name" label="Name" />
          <ImporterField name="email" label="Email" />
          <ImporterField name="subscribe_date" label="Subscribe Date" optional />
          <ImporterField name="city" label="City" optional />
          <ImporterField name="state" label="State" optional />
          <ImporterField name="country" label="Country" optional />
          <ImporterField name="subscriptions" label="Subscriptions" optional />
        </Importer>
      </Modal>
    </>
  );
}
